import React from "react";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import styles from "../../FilePreviewModal.module.scss";

interface DocumentPreviewProps {
  fileUrl: string;
}

const WordPreview: React.FC<DocumentPreviewProps> = ({ fileUrl }) => {
  const docs = [{ uri: fileUrl, fileType: "application/msword" }]; // Explicitly define fileType

  return (
    <div className={`overflow-hidden ${styles.pdfContainer}`}>
      <DocViewer 
        documents={docs} 
        pluginRenderers={DocViewerRenderers} 
        config={{ header: { disableHeader: true } }} 
        style={{ width: "100%", height: "100%", overflow:"hidden"  }}
      />
    </div>
  );
};

export default WordPreview;
